/* eslint-disable */
import { AUTH_TNC_LINK_CLICKED } from '../Auth.types';

/**
 * Auth action for T&C action
 * @returns {ActionCreator<FromPromise<AuthEntity, Error, {}, AUTH_TNC_LINK_CLICKED>>} The created `Action`
 */
const authTnc = () => ({ fromPayload }) => {
  return fromPayload(null, {}, AUTH_TNC_LINK_CLICKED);
};

export default authTnc;
